import { Checkbox, IFormRender } from '@busybusy/webapp-react-ui';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { t } from 'i18next';
import { useState } from 'react';
import { ICreatePositionsFormData } from '../../forms/create-position-form/CreatePositionForm';

export interface IRequireDescriptionFormFieldsProps<T extends ICreatePositionsFormData> {
  form: IFormRender<T>;
}

interface IRequireDescriptionFormFieldsFormData {
  enabled: boolean;
}

function RequireDescriptionFormFields<T extends ICreatePositionsFormData>({
  form,
}: IRequireDescriptionFormFieldsProps<T>) {
  const [settings, setSettings] = useState<IRequireDescriptionFormFieldsFormData>(getInitialData());

  function getInitialData() {
    if (form.state.data.requireTimeEntryDescription) {
      return { enabled: true };
    } else {
      return { enabled: false };
    }
  }

  return (
    <>
      <Checkbox
        key={'enabled'}
        className="my-4"
        checked={settings.enabled}
        label={
          <HeaderText title={t('Require Description')}>
            <span>
              {t(
                'When clocking their own time, require employees to have a description on their time entry before switching or clocking out.'
              )}
            </span>
          </HeaderText>
        }
        onChange={(value) => {
          setSettings({ enabled: value });
          form.state.data.requireTimeEntryDescription = value;
        }}
      />
    </>
  );
}

export default RequireDescriptionFormFields;
